// after typing a long text, show it from the beginning for Firefox, Edge and IE
export const moveInputCursorToStart = (inputElement, value) => {
  inputElement.value = value; // eslint-disable-line no-param-reassign
  inputElement.scrollLeft = 0; // eslint-disable-line no-param-reassign
};
